import { render, staticRenderFns } from "./KListItemIcon.vue?vue&type=template&id=81984f70"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemIcon})
